import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router';
import { getCurrentUser } from 'aws-amplify/auth';

export default function PrivateRoute({ render, ...other }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthenticated();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuthenticated = async () => {
    setIsLoading(true);
    try {
      const user = await getCurrentUser();
      setIsAuthenticated(Boolean(user));
    } catch {
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <Route
      {...other}
      render={
        isAuthenticated ? render : (props) => <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
      }
    />
  );
}
